"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EscrowRouter = void 0;
const escrow_sdk_old_1 = require("escrow-sdk-old");
const index_1 = require("../../index");
const types_1 = require("../types");
const utils_1 = require("../utils");
class EscrowRouter {
    constructor(connection, pubkey, configId, pubkeyOld, configIdOld) {
        this.pubkeyOld = pubkeyOld;
        this.pubkey = pubkey;
        this.configIdOld = configIdOld;
        this.configId = configId;
        const pdaCurrent = new index_1.PDA(pubkey, configId);
        this.fetcher = new index_1.EscrowFetcher(connection, pdaCurrent);
        if (pubkeyOld && configIdOld) {
            const pdaOld = new escrow_sdk_old_1.PDA(pubkeyOld, configIdOld);
            this.fetcherOld = new escrow_sdk_old_1.EscrowFetcher(connection, pdaOld);
        }
    }
    /**
     * @dev get trade by status and side optinally
     * @param tradeStatus : Awaiting | Deposited | Disputed | Released | Canceled
     * @param side  : Buy | Sell (if not provided, will return both buy and sell)
     * @returns ITradeDataInfo[]
     */
    getTradesByStatus(tradeStatus, side) {
        return __awaiter(this, void 0, void 0, function* () {
            let filteredOldTrades = [];
            if (this.fetcherOld) {
                yield this.fetcherOld.refreshAll();
                const tradesOld = yield this.fetcherOld.getTradesByStatus((0, utils_1.getOldTradeState)(tradeStatus));
                if (side == index_1.TradeSide.Sell) {
                    filteredOldTrades = tradesOld.filter((trade) => trade !== null);
                }
            }
            yield this.fetcher.refreshAll();
            let tradesCurrent = [];
            if (side) {
                tradesCurrent = yield this.fetcher.getTradesByStatus(tradeStatus, side);
            }
            else {
                tradesCurrent = yield this.fetcher.getTradesByStatus(tradeStatus);
            }
            return [...(0, utils_1.convertOldTrades)(filteredOldTrades), ...(0, utils_1.convertCurrentTrades)(tradesCurrent)];
        });
    }
    getOffersByStatus(offerStatus, side) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.fetcher.refreshAll();
            let offersCurrent = [];
            console.log("93 side: ", side);
            if (side) {
                offersCurrent = yield this.fetcher.getOffersByStatus(offerStatus, side);
            }
            else {
                offersCurrent = yield this.fetcher.getOffersByStatus(offerStatus);
            }
            return offersCurrent;
        });
    }
    getTradesByBuyerAddress(buyerAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            let filteredOldTrades = [];
            if (this.fetcherOld) {
                yield this.fetcherOld.refreshAll();
                const tradesOld = yield this.fetcherOld.getTradesByBuyerAddress(buyerAddress);
                filteredOldTrades = tradesOld.filter((trade) => trade !== null);
            }
            yield this.fetcher.refreshAll();
            const tradesCurrent = yield this.fetcher.getTradesByBuyerAddress(buyerAddress);
            return [...(0, utils_1.convertOldTrades)(filteredOldTrades), ...(0, utils_1.convertCurrentTrades)(tradesCurrent)];
        });
    }
    getTradesBySellerAddress(sellerAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            let filteredOldTrades = [];
            if (this.fetcherOld) {
                yield this.fetcherOld.refreshAll();
                const tradesOld = yield this.fetcherOld.getTradesBySellerAddress(sellerAddress);
                filteredOldTrades = tradesOld.filter((trade) => trade !== null);
            }
            yield this.fetcher.refreshAll();
            const tradesCurrent = yield this.fetcher.getTradesBySellerAddress(sellerAddress);
            return [...(0, utils_1.convertOldTrades)(filteredOldTrades), ...(0, utils_1.convertCurrentTrades)(tradesCurrent)];
        });
    }
    /**
     * a function to get trade data by trade id
     */
    getTradeDataByID(tradeId, version, refresh = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (version === types_1.Version.Old && this.fetcherOld) {
                yield this.fetcherOld.refreshAll();
                const tradeOld = yield this.fetcherOld.getTradeOrder(tradeId);
                if (!tradeOld)
                    return null;
                return (0, utils_1.convertOldTrades)([tradeOld])[0];
            }
            else {
                yield this.fetcher.refreshAll();
                const tradeCurrent = yield this.fetcher.getTradeInfo(tradeId, refresh);
                if (!tradeCurrent)
                    return null;
                return (0, utils_1.convertCurrentTrades)([tradeCurrent])[0];
            }
        });
    }
    /**
     * a function to make a new offer
     * @param wallet user wallet
     * @param tokenMint mint of token that user want to create offer with
     * @param bondType type of bond. Can either be Spl or Native. Use "BondType" value from sdk
     * @param minTradeSize minimum size of trade can be created from the offer. Should be between "0.2" and "1"
     * @param tokenAmount total amount of token that user want to create offer with
     * @param fiatAmount equivalent number of fiat amount
     * @returns
     */
    makeOffer(wallet, tokenMint, side, bondType, minTradeSize, tokenAmount, fiatAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            const minTradeSizeU64 = (0, index_1.getMinTradeSize)(minTradeSize);
            return yield index_1.OfferClient.makeOffer((0, utils_1.getContextCurrent)(this.fetcher.connection, wallet, this.pubkey), this.configId, side, wallet.publicKey, tokenMint, bondType, minTradeSizeU64, tokenAmount, fiatAmount);
        });
    }
    /**
     * a function to request create trade from an existing offer
     * @param wallet user wallet
     * @param offerId offer Id that user want to create trade with
     * @param tokenAmount amount of token that user want to trade
     * @param offerClient optional: if user already have offerClient, pass it to this function to avoid fetching data from blockchain
     * @returns { tx: TransactionBuilder; id: BN } transaction to requestCreateOffer && tradeID
     */
    requestCreateTrade(wallet, offerId, tokenAmount, offerClient) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!offerClient) {
                offerClient = yield index_1.OfferClient.getOffer((0, utils_1.getContextCurrent)(this.fetcher.connection, wallet, this.pubkey), this.configId, offerId);
            }
            const tx = yield offerClient.requestCreateTrade(wallet.publicKey, tokenAmount);
            return tx;
        });
    }
    cancelTrade(wallet, tradeData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (tradeData.version == types_1.Version.Old) {
                if (!this.fetcherOld || !this.pubkeyOld || !this.configIdOld) {
                    throw new Error("Old escrow config not found");
                }
                const tradeOld = (0, utils_1.getTradeOldClient)((0, utils_1.getContextOld)(this.fetcherOld.connection, wallet, this.pubkeyOld), this.configIdOld, tradeData);
                return tradeOld.cancelOrder(wallet.publicKey);
            }
            else {
                const tradeCurrent = (0, utils_1.getTradeCurrentClient)((0, utils_1.getContextCurrent)(this.fetcher.connection, wallet, this.pubkey), this.configId, tradeData);
                return tradeCurrent.cancelTrade(wallet.publicKey);
            }
        });
    }
    cancelOffer(wallet, offerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const offer = yield index_1.OfferClient.getOffer((0, utils_1.getContextCurrent)(this.fetcher.connection, wallet, this.pubkey), this.configId, offerId);
            const { tx: cancelOfferTx } = yield offer.cancelOffer();
            return cancelOfferTx;
        });
    }
    release(wallet, tradeData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (tradeData.version == types_1.Version.Old) {
                if (!this.fetcherOld || !this.pubkeyOld || !this.configIdOld) {
                    throw new Error("Old escrow config not found");
                }
                const tradeOld = (0, utils_1.getTradeOldClient)((0, utils_1.getContextOld)(this.fetcherOld.connection, wallet, this.pubkeyOld), this.configIdOld, tradeData);
                return tradeOld.release();
            }
            else {
                const tradeCurrent = (0, utils_1.getTradeCurrentClient)((0, utils_1.getContextCurrent)(this.fetcher.connection, wallet, this.pubkey), this.configId, tradeData);
                return tradeCurrent.release();
            }
        });
    }
    callArbitrator(wallet, tradeData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (tradeData.version == types_1.Version.Old) {
                if (!this.fetcherOld || !this.pubkeyOld || !this.configIdOld) {
                    throw new Error("Old escrow config not found");
                }
                const tradeOld = (0, utils_1.getTradeOldClient)((0, utils_1.getContextOld)(this.fetcherOld.connection, wallet, this.pubkeyOld), this.configIdOld, tradeData);
                return tradeOld.callArbitrator(wallet.publicKey);
            }
            else {
                const tradeCurrent = (0, utils_1.getTradeCurrentClient)((0, utils_1.getContextCurrent)(this.fetcher.connection, wallet, this.pubkey), this.configId, tradeData);
                return tradeCurrent.callArbitrator(wallet.publicKey);
            }
        });
    }
    resolveDispute(wallet, tradeData, disputeAction, compensationAction) {
        return __awaiter(this, void 0, void 0, function* () {
            if (tradeData.version == types_1.Version.Old) {
                if (!this.fetcherOld || !this.pubkeyOld || !this.configIdOld) {
                    throw new Error("Old escrow config not found");
                }
                const tradeOld = (0, utils_1.getTradeOldClient)((0, utils_1.getContextOld)(this.fetcherOld.connection, wallet, this.pubkeyOld), this.configIdOld, tradeData);
                return tradeOld.resolveDispute(wallet.publicKey, disputeAction, compensationAction);
            }
            else {
                const tradeCurrent = (0, utils_1.getTradeCurrentClient)((0, utils_1.getContextCurrent)(this.fetcher.connection, wallet, this.pubkey), this.configId, tradeData);
                return tradeCurrent.resolveDispute(wallet.publicKey, disputeAction, compensationAction);
            }
        });
    }
}
exports.EscrowRouter = EscrowRouter;
